import type {BasisType, Goal, INormalize} from "@raskrask-dk/raskrask-utils";
import type {IGoalDTO} from "..";
import type {DomainMapper, IdValTuple, MapById} from "./mapper.types";

export class GoalMapper implements DomainMapper<Goal, IGoalDTO> {
  constructor(private goalConstructor: (goalDTO: IGoalDTO) => Goal) {}

  fromDTO(dto: IGoalDTO): Goal {
    return this.goalConstructor(dto);
  }

  toDTO(goal: Goal): IGoalDTO {
    return {
      id: goal.id,
      name: goal.name,
      serviceIds: goal.services.map((service) => service.id),
    };
  }

  fromDtoToTuple(dto: IGoalDTO): IdValTuple<Goal> {
    return [dto.id, this.fromDTO(dto)];
  }

  fromNormalized(goals: INormalize<IGoalDTO>, basisType: BasisType): MapById<Goal> {
    return new Map(
      goals.allIds.map((id) => {
        const goal = this.fromDTO(goals.byId[id]);
        goal.addBasisTypeId(basisType.id);
        return [parseInt(id), goal];
      })
    );
  }
}
